import { render, staticRenderFns } from "./QuotaChart.vue?vue&type=template&id=3a2192ba&"
import script from "./QuotaChart.vue?vue&type=script&lang=js&"
export * from "./QuotaChart.vue?vue&type=script&lang=js&"
import style0 from "./QuotaChart.vue?vue&type=style&index=0&id=3a2192ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports